import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PublicNav, PublicFooter } from "@/components/PublicLayout";
import { AssistantWidget } from "@/components/AssistantWidget";
import Home from "@/pages/Home";
import SobreMi from "@/pages/SobreMi";
import Servicios from "@/pages/Servicios";
import Forense from "@/pages/Forense";
import Blog from "@/pages/Blog";
import Contacto from "@/pages/Contacto";
import Tienda from "@/pages/Tienda";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";

const Public = ({ children }) => (
  <>
    <PublicNav />
    <main>{children}</main>
    <PublicFooter />
    <AssistantWidget />
  </>
);

const Protected = ({ role, children }) => {
  const { user, loading, mustChange } = useAuth();
  const { pathname } = useLocation();
  if (loading) return <div className="p-12 text-sm text-[#5e5a56]">Cargando...</div>;
  if (!user) return <Navigate to={role === "admin" ? "/acceso-administrador" : "/portal"} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  if (mustChange) return <ChangePassword />;
  return children;
};

const PortalEntry = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-sm text-[#5e5a56]">Cargando...</div>;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/portal/inicio"} replace />;
  return <Login />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/sobre-mi" element={<Public><SobreMi /></Public>} />
          <Route path="/servicios" element={<Public><Servicios /></Public>} />
          <Route path="/psicopedagogia-forense" element={<Public><Forense /></Public>} />
          <Route path="/blog" element={<Public><Blog /></Public>} />
          <Route path="/tienda" element={<Public><Tienda /></Public>} />
          <Route path="/contacto" element={<Public><Contacto /></Public>} />
          <Route path="/portal" element={<PortalEntry />} />
          <Route path="/acceso-administrador" element={<Login admin />} />
          <Route path="/portal/inicio" element={<Protected role="patient"><Portal /></Protected>} />
          <Route path="/admin" element={<Protected role="admin"><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
